var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-view", {
                attrs: {
                  title: _vm.$t("message.contactPersonDetails.title"),
                  icon: "ti-user"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              _c("business-card", {
                attrs: {
                  name: _vm.name,
                  relation: _vm.relationship,
                  email: _vm.contactPerson.email,
                  imageSrc: _vm.contactPerson.avatarUuid,
                  variant: "noHover"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-btn",
                { attrs: { variant: "link", to: "/contactPersons" } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("message.contactPersonDetails.btn.back")) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "text-right" },
            [
              _c(
                "b-btn",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.delete-contact-person-modal",
                      modifiers: { "delete-contact-person-modal": true }
                    }
                  ],
                  staticClass: "rounded-0",
                  attrs: { variant: "danger" }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("message.contactPersonDetails.btn.delete")
                      ) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-5" },
        [
          _c(
            "b-col",
            [
              _c("contracts-card", {
                attrs: {
                  collapseId: "contact-persons-contracts-card",
                  items: _vm.contracts,
                  title: _vm.$t(
                    "message.contactPersonDetails.contractsCard.title",
                    {
                      firstName: _vm.contactPerson.firstName,
                      lastName: _vm.contactPerson.lastName
                    }
                  )
                },
                on: { showDetails: _vm.showDetails }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "delete-contact-person-modal",
            "cancel-variant": "danger",
            "ok-variant": "success",
            title: _vm.$t("message.contactPersonDetails.modal.title"),
            "ok-title": _vm.$t("message.contactPersonDetails.modal.btn.ok"),
            "cancel-title": _vm.$t(
              "message.contactPersonDetails.modal.btn.cancel"
            )
          },
          on: { ok: _vm.deleteContactPerson }
        },
        [
          _c("p", { staticClass: "mt-4" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("message.contactPersonDetails.modal.question", {
                    salutation: _vm.$t(
                      "enums.salutations." + _vm.contactPerson.salutation
                    ),
                    firstName: _vm.contactPerson.firstName,
                    lastName: _vm.contactPerson.lastName
                  })
                ) +
                "\n    "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96995c52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96995c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactPerson/ContactPersonDetails.vue
// module id = lZqn
// module chunks = 1